import React, { useState, useEffect } from 'react'
import api from '../../core/api'
import { CircularProgress, Grid } from '@material-ui/core'
import { useAppContext } from '../singletons/AppContext'

export default function CategoriesContainer({ key, children }) {
	const [ state, setState ] = useState({
		categories: [],
		loading: true,
		error: null
	})
	const { setAppState } = useAppContext()

	/**
	 *
	 * @param {import('axios').AxiosInstance} api
	 */
	async function fetchData() {
		setState({ loading: true, error: null })
		try {
			const { data: categories } = await api.get(`/categories`)
			setState({ ...state, categories, loading: false })
		} catch (e) {
			if (e.response)
				setState({
					...state,
					error: {
						payload: e.response.data
					}
				})
			else setState({ ...state, error: {} })
		}
	}

	useEffect(
		() => {
			fetchData()
			setAppState({ onReloadData: () => fetchData() })
		},
		[ key ]
	)

	if (state.error) {
		return (
			<div>
				<p style={{ textAlign: 'center' }}>Ocorreu um erro ao obter os dados.</p>
				<p style={{ textAlign: 'center' }}>
					<a href="javascript:void(0)" onClick={fetchData}>
						Tentar novamente
					</a>
				</p>
			</div>
		)
	}

	if (state.loading) {
		return (
			<div className="flex-col center-b center-a">
				<span style={{ paddingTop: '10em' }}>
					<CircularProgress size={100} />
					<p> Carregando... </p>
				</span>
			</div>
		)
	}

	return (
		<Grid container xs={12}>
			{children({
				categories: state.categories.sort((a, b) => {
					if (a.name > b.name) {
						return 1
					}
					if (a.name < b.name) {
						return -1
					}
					return 0
				}),
				fetchData
			})}
		</Grid>
	)

	return
}
